import { render } from "./FormRadioFieldComponent.vue?vue&type=template&id=50440d3a&scoped=true"
import script from "./FormRadioFieldComponent.vue?vue&type=script&lang=js"
export * from "./FormRadioFieldComponent.vue?vue&type=script&lang=js"

import "./FormRadioFieldComponent.vue?vue&type=style&index=0&id=50440d3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50440d3a"]])

export default __exports__